import { BigNumber } from "ethers"
import { BIG_ZERO } from "src/constants/bigNumber"
import { DeserializedFerroBoostStake } from "src/state/xFer/types"

const calculateAccruedFer = (
  poolId: number,
  pendingFer: BigNumber,
  stakes: DeserializedFerroBoostStake[],
): BigNumber => {
  let poolWeight = BIG_ZERO
  let totalWeight = BIG_ZERO
  for (let i = 0; i < stakes.length; i++) {
    const stake = stakes[i]
    if (stake.active) {
      totalWeight = stake.weightedAmount.add(totalWeight)
      if (stake.poolId === poolId) {
        poolWeight = stake.weightedAmount.add(poolWeight)
      }
    }
  }
  if (totalWeight.eq(0)) {
    return BIG_ZERO
  }
  return pendingFer.mul(poolWeight).div(totalWeight)
}

export default calculateAccruedFer
